let th_wc_cs_shop_money=document.querySelector('.th_custom_work_money_format').getAttribute('content');
var Shopify = Shopify || {}; Shopify.money_format = th_wc_cs_shop_money, Shopify.formatMoney = function (a, e) { "string" == typeof a && (a = a.replace(".", "")); var o = "", r = /\{\{\s*(\w+)\s*\}\}/, t = e || this.money_format; function n(a, e) { return void 0 === a ? e : a } function i(a, e, o, r) { if (e = n(e, 2), o = n(o, ","), r = n(r, "."), isNaN(a) || null == a) return 0; var t = (a = (a / 100).toFixed(e)).split("."); return t[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (t[1] ? r + t[1] : "") } switch (t.match(r)[1]) { case "amount": o = i(a, 2); break; case "amount_no_decimals": o = i(a, 0); break; case "amount_with_comma_separator": o = i(a, 2, ".", ","); break; case "amount_no_decimals_with_comma_separator": o = i(a, 0, ".", ",") }return t.replace(r, o) };
let returns_format_money = (final) => { return Shopify.formatMoney(final, th_wc_cs_shop_money) }

let $th_bundle_success_callback=(th_bundle_id,$th_bundle_result)=>{
  let th_pb_combo_offer_code=document.querySelector('.th_pb_combo_offer_code');
  if(th_pb_combo_offer_code){
    let th_combo_change_total_compare_price=()=>{
          let th_compare_at_price_total=0;
          let thpb_combo_p_grid_lists=document.querySelectorAll('.thpb_combo_p_grid_list');
          thpb_combo_p_grid_lists.forEach((thsb_combo_product_grid)=>{
            let p_grid_product_id=thsb_combo_product_grid.dataset.pid;
            let p_grid_current_selected_index_of_variant=thsb_combo_product_grid.querySelector('.thpb_combo_p_grid_main_variants').selectedIndex;
            if($th_bundle_result.combo_bundle_list!=[]){
              $th_bundle_result.combo_bundle_list[0].product_list.forEach((cmb_json_product)=>{
                if(cmb_json_product.id==p_grid_product_id && cmb_json_product.variants.length>0){
                   let cmb_json_compare_at_price=cmb_json_product.variants[p_grid_current_selected_index_of_variant].compare_at_price;
                   let cmb_json_price=cmb_json_product.variants[p_grid_current_selected_index_of_variant].price;
                   
                   if(cmb_json_compare_at_price!=undefined && cmb_json_compare_at_price!=0){
                    th_compare_at_price_total+=parseFloat(cmb_json_compare_at_price); 
                   }else{
                     th_compare_at_price_total+=parseFloat(cmb_json_price); 
                   }
                }
              })
            }
          })
      
          let th_theme_compare_at_price_elenent=document.querySelector('.price__container .th_pb_line_through');
          console.log("th_compare_at_price_total,",th_compare_at_price_total)
          th_theme_compare_at_price_elenent.innerHTML=returns_format_money(th_compare_at_price_total*100);
    }
    th_combo_change_total_compare_price();
    let th_all_combo_bundle_select_elements=document.querySelectorAll('.thpb_combo_p_grid_variant_select');
    th_all_combo_bundle_select_elements.forEach((th_cmb_select_element)=>{
      th_cmb_select_element.addEventListener('click',()=>{
        th_combo_change_total_compare_price();
      })
    })
  }
}


let th_apply_compare_at_price_as_requerement=()=>{
  if(window.location.href.indexOf('/cart') > -1){

    let th_compare_at_price_total=0;
    let th_line_items=document.querySelectorAll('.cart-page .cart-item');
    th_line_items.forEach((line_item)=>{
      let line_item_compare_at_price=line_item.dataset.th_compare_at_price;
      let line_item_quatity=line_item.dataset.th_quantity;
      let line_itme_bundle_property=line_item.dataset.th_property;
      if(line_item_compare_at_price!='' && line_item_quatity!=undefined && line_itme_bundle_property!=''){
        th_compare_at_price_total+=parseFloat(line_item_compare_at_price)*parseFloat(line_item_quatity);
      }else{
        th_compare_at_price_total+=parseFloat(line_item.dataset.thpriceoriginal);
      }
    })
    let th_copmare_at_price_elements=document.querySelectorAll('.th_cart_total_original_price .th_pb_line_through');
    
    th_copmare_at_price_elements.forEach((th_compare_price_element)=>{
         
      if(th_compare_price_element){
       th_compare_price_element.innerHTML=returns_format_money(th_compare_at_price_total)
      } 
    })
  }else{
    let drawer_cart_items=document.querySelectorAll('cart-drawer .cart-item')
    let th_compare_at_price_total=0;
    drawer_cart_items.forEach((line_item)=>{
      let line_item_compare_at_price=line_item.dataset.th_compare_at_price;
      let line_item_quatity=line_item.dataset.th_quantity;
      let line_itme_bundle_property=line_item.dataset.th_property;
      if(line_item_compare_at_price!='' && line_item_quatity!=undefined && line_itme_bundle_property!=''){
        th_compare_at_price_total+=parseFloat(line_item_compare_at_price)*parseFloat(line_item_quatity);
      }else{
        th_compare_at_price_total+=parseFloat(line_item.dataset.thpriceoriginal);
      }
    })
    let th_copmare_at_price_elements=document.querySelectorAll('.th_cart_total_original_price .th_pb_line_through');
    th_copmare_at_price_elements.forEach((th_compare_price_element)=>{
      if(th_compare_price_element){
       th_compare_price_element.innerHTML=returns_format_money(th_compare_at_price_total)
      } 
    })
  }
}



window.fetch = new Proxy(window.fetch, {
        apply($wcpb_fetch, $wcpb_that, $wcpb_args) {
            var $wcpb_result = $wcpb_fetch.apply($wcpb_that, $wcpb_args);
            return $wcpb_result.then(async (response) => {
                if ($wcpb_args[0].search(/cart.*js|cart\/change|cart\/add/) >= 0 && $wcpb_args[0].indexOf('/cart.js?currency=') == -1 && $wcpb_args[0].indexOf('/cart.js?bundle') == -1 && $wcpb_args[0].indexOf('/cart.js?src=ss') == -1 && $wcpb_args[0].indexOf('/cart.json?icu=1') == -1) {
                  console.log("cart changes happens ----------------------")
                  let interval_count=0;
                  let th_setinterval=setInterval(()=>{
                    interval_count++;
                    th_apply_compare_at_price_as_requerement();
                    if(interval_count>10){
                      clearInterval(th_setinterval);
                    }
                  },1000)
                }
            }), $wcpb_result
        }
});

let th_apply_compare_price=()=>{
  setTimeout(()=>{
      let interval_count=0;
      let th_setinterval=setInterval(()=>{
        interval_count++;
        th_apply_compare_at_price_as_requerement();
        if(interval_count>10){
            clearInterval(th_setinterval);
        }
     },1000)
  },1000)
}

let wc_interval_count=0;
      let th_setinterval=setInterval(()=>{
        wc_interval_count++;
        th_apply_compare_at_price_as_requerement();
        if(wc_interval_count>10){
            clearInterval(th_setinterval);
        }
},1000)